import type { LocaleResources } from 'locales';
import { CommonModal } from 'src/components/shared/elements/modals/CommonModal';
import type { Product } from 'src/models/product/schema';
import { getDiscountRateByLocale } from 'src/utils/medicine';
import { toJSX } from 'src/utils/toJSXHelper';

type Props = {
  product: Product;
  localeResources: LocaleResources;
  closeModal: () => void;
  onAddCartButtonClick: () => void;
  locale: string | undefined;
};

export const Presenter: React.FC<Props> = ({ product, localeResources, closeModal, onAddCartButtonClick, locale }) => (
  <CommonModal
    closeModal={closeModal}
    fixedElement={
      <div className="py-3 flex flex-col gap-4 items-center text-center">
        <div className="text-xl font-semibold">
          {toJSX(localeResources.discountNotice.mainText('text-primary', getDiscountRateByLocale(locale)))}
        </div>
        <div>{localeResources.discountNotice.description}</div>
        {product.orderable && (
          <button
            type="button"
            className="w-60 h-10 rounded-full semiLg:cursor-pointer bg-primary text-white shadow-primaryButton semiLg:hover:opacity-70 semiLg:transition-opacity semiLg:duration-200"
            onClick={onAddCartButtonClick}
          >
            {localeResources.cart.addToCart}
          </button>
        )}
      </div>
    }
  />
);
